import styled, {css} from 'styled-components'

const defaultArrowBtnWidth = '48px'

const ArrowButton = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: var(--arrow-btn-width, ${defaultArrowBtnWidth});
  height: var(--arrow-btn-width, ${defaultArrowBtnWidth});
  border-radius: 50%;
  color: var(--arrow-btn-color, #fff);
  background: var(--arrow-btn-bg, var(--color-decor));
  transition: background 0.3s ease-out;

  svg {
    width: calc(var(--arrow-btn-width, defaultArrowBtnWidth) * 0.33);
    height: auto;
    transform: rotate(180deg);
  }

  ${(props) =>
    props.reverse == true &&
    css`
      svg {
        transform:unset;
      }
    `}
    

  &::after {
    content: var(--arrow-btn-shadow-content, '');
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    opacity: var(--arrow-btn-shadow-opacity, 0);
    box-shadow: 0px 4px 8px rgba(17, 33, 70, 0.16);
    transition: opacity 0.3s ease-out;
  }
`

export default ArrowButton
